(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdh-baby-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mdh-baby-banner')) {
  customElements.define('mdh-baby-banner', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.slides = [...this.querySelectorAll('.mdh-baby-slide')];
      this.tabs = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
      this.hovered = false;
      this.focused = false;
      this.tabs.forEach((tab,i) => tab.addEventListener('click',()=>this.show(i),options));
      this.querySelector('[data-prev]').addEventListener('click',()=>this.show(this.index-1),options);
      this.querySelector('[data-next]').addEventListener('click',()=>this.show(this.index+1),options);
      this.querySelector('[data-pause]').addEventListener('click',()=>{this.paused=!this.paused;this.updatePause();this.schedule();},options);
      this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule();},options);
      this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule();},options);
      this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},options);
      this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule();});},options);
      this.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.show(this.index+(event.key==='ArrowRight'?1:-1));}},options);
      document.addEventListener('visibilitychange',()=>this.schedule(),options);
      document.addEventListener('shopify:block:select',event=>{const i=this.slides.indexOf(event.target);if(i>=0){this.paused=true;this.show(i);this.updatePause();}},options);
      this.reduced.addEventListener('change',()=>{if(this.reduced.matches){this.paused=true;this.updatePause();}this.schedule();},options);
      this.updatePause();this.schedule();
    }
    show(index) {
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{const active=i===this.index;slide.classList.toggle('is-active',active);slide.inert=!active;slide.setAttribute('aria-hidden',String(!active));});
      this.tabs.forEach((tab,i)=>{if(i===this.index)tab.setAttribute('aria-current','true');else tab.removeAttribute('aria-current');});
      this.slides[this.index].querySelectorAll('img').forEach(img=>img.loading='eager');
      this.schedule();
    }
    updatePause() {const button=this.querySelector('[data-pause]');button.setAttribute('aria-label',this.paused?button.dataset.playLabel:button.dataset.pauseLabel);button.querySelector('span').textContent=this.paused?'▶':'Ⅱ';}
    schedule() {clearTimeout(this.timer);if(this.paused||this.hovered||this.focused||document.hidden||this.reduced.matches||this.slides.length<2)return;this.timer=setTimeout(()=>this.show(this.index+1),Math.max(5000,Number(this.dataset.interval)||7000));}
    disconnectedCallback() {clearTimeout(this.timer);this.controller?.abort();this.controller=null;}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdh-category-nav"]) return;
  try {
    
document.querySelectorAll('[data-mdh-baby-menu]').forEach(menu=>{
  menu.addEventListener('mouseenter',()=>{if(window.matchMedia('(hover: hover) and (pointer: fine)').matches){document.querySelectorAll('[data-mdh-baby-menu]').forEach(other=>{if(other!==menu)other.open=false;});menu.open=true;}});
  menu.addEventListener('mouseleave',()=>{if(window.matchMedia('(hover: hover) and (pointer: fine)').matches&&!menu.contains(document.activeElement))menu.open=false;});
  menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}});
  document.addEventListener('click',event=>{if(!menu.contains(event.target))menu.open=false;});
});

  } catch(e) { console.error(e); }
})();
})();
